export default __webpack_public_path__ + "static/media/money.a49317e0.svg";